module.exports = __webpack_public_path__ + "static/img/text-intro-fr.ec351d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/wait/img/text-intro-fr.png
// module id = o+wG
// module chunks = 1